"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createThemeConfig = void 0;
function insertFaviconElement(themeName) {
    const faviconEl = document.createElement('link');
    faviconEl.rel = 'icon';
    faviconEl.href = `/assets/shared/${themeName}/favicon.ico`;
    document.head.appendChild(faviconEl);
}
/**
 * Constructs the theme configuration based on the current host name.
 *
 * Allows for white-labelling by applying the appropriate class name to the document's body
 * and providing theme-specific properties which can be accessed by each single-spa.
 *
 * To test the theme is being applied correctly, you can either navigate to the expected hostname or
 * set the hostname in local storage (handy for testing on Dev), e.g.
 * localStorage.setItem('test-hostname', 'portal.flex.edfenergy.com') and then reload the page.
 */
function createThemeConfig() {
    let name = 'krakenflex';
    const mockHostName = localStorage.getItem('test-hostname');
    if ([window.location.host, mockHostName].includes('portal.flex.edfenergy.com')) {
        document.body.classList.add('theme-edf');
        name = 'edf';
    }
    insertFaviconElement(name);
    return {
        name,
        path: `/assets/shared/${name}`,
    };
}
exports.createThemeConfig = createThemeConfig;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdGhlbWUtY29uZmlnL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQU9BLFNBQVMsb0JBQW9CLENBQUMsU0FBaUI7SUFDN0MsTUFBTSxTQUFTLEdBQUcsUUFBUSxDQUFDLGFBQWEsQ0FBQyxNQUFNLENBQUMsQ0FBQztJQUNqRCxTQUFTLENBQUMsR0FBRyxHQUFHLE1BQU0sQ0FBQztJQUN2QixTQUFTLENBQUMsSUFBSSxHQUFHLGtCQUFrQixTQUFTLGNBQWMsQ0FBQztJQUMzRCxRQUFRLENBQUMsSUFBSSxDQUFDLFdBQVcsQ0FBQyxTQUFTLENBQUMsQ0FBQztBQUN2QyxDQUFDO0FBRUQ7Ozs7Ozs7OztHQVNHO0FBQ0gsU0FBZ0IsaUJBQWlCO0lBQy9CLElBQUksSUFBSSxHQUFjLFlBQVksQ0FBQztJQUVuQyxNQUFNLFlBQVksR0FBRyxZQUFZLENBQUMsT0FBTyxDQUFDLGVBQWUsQ0FBQyxDQUFDO0lBRTNELElBQUksQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFDLElBQUksRUFBRSxZQUFZLENBQUMsQ0FBQyxRQUFRLENBQUMsMkJBQTJCLENBQUMsRUFBRSxDQUFDO1FBQy9FLFFBQVEsQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLEdBQUcsQ0FBQyxXQUFXLENBQUMsQ0FBQztRQUN6QyxJQUFJLEdBQUcsS0FBSyxDQUFDO0lBQ2YsQ0FBQztJQUVELG9CQUFvQixDQUFDLElBQUksQ0FBQyxDQUFDO0lBRTNCLE9BQU87UUFDTCxJQUFJO1FBQ0osSUFBSSxFQUFFLGtCQUFrQixJQUFJLEVBQUU7S0FDL0IsQ0FBQztBQUNKLENBQUM7QUFoQkQsOENBZ0JDIn0=